import React from 'react';
import { StaticImageData } from 'next/image';
import Image from '@/Framework/Router/Next/Image';

import cardStyles from '@dealroadshow/uikit/core/styles/card.scss';
import officeStyles from './office.scss';

interface IProps {
  photo: StaticImageData,
  name: string,
  address: string[],
}

const Office = ({ photo, name, address }: IProps) => (
  <div className={ officeStyles.office }>
    <div className={ cardStyles.cardContainer }>
      <Image
        title={ name }
        width={ 223 }
        height={ 147 }
        src={ photo }
        alt={ name }
      />
      <div className={ officeStyles.textWrapper }>
        <div className={ officeStyles.officeTitle }>
          { name }
        </div>
        <div className={ officeStyles.feedbackAuthor }>
          { address.map((item) => <div key={ item }>{ item }</div>) }
        </div>
      </div>
    </div>
  </div>
);

export default Office;
